import { render, staticRenderFns } from "./ImageTextAdd.vue?vue&type=template&id=2d422d03&"
import script from "./ImageTextAdd.vue?vue&type=script&lang=js&"
export * from "./ImageTextAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports